import { createSelector } from 'reselect'

import { flatten } from 'lodash'

import { mapEventCategory, mapEvent, mapEventDetails } from 'api-data-io/cms/eventCategories'

import { getFlightsOffersError } from 'selectors/flightsOffers'

const getEventCategories = state => state.eventCategories

export const getEventCategoriesData = createSelector(
  [getEventCategories],
  state => (state ? state.data : null)
)

export const getEventCategoriesList = createSelector(
  [getEventCategoriesData],
  data => (data ? data.map(eventsByCategory => mapEventCategory(eventsByCategory)) : [])
)

export const getEventsList = createSelector(
  [getEventCategoriesData],
  data =>
    data
      ? flatten(
          data.map(eventsByCategory =>
            eventsByCategory.eventReference.map(event => mapEvent(event))
          )
        )
      : []
)

export const getEventsDetailsList = createSelector(
  [getEventCategoriesData],
  data =>
    data
      ? flatten(
          data.map(eventsByCategory =>
            eventsByCategory.eventReference.map(event => mapEventDetails(event, eventsByCategory))
          )
        )
      : []
)

export const getConferenceCodeError = createSelector(
  [getFlightsOffersError],
  error =>
    error &&
    error.statusCode === 400 &&
    error.description.find(i => i === 'gds.flight.error.invalid-conference-fields')
)
